import React from 'react'
import { DownOutlined, UserOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { Button, Dropdown, message, Space, Tooltip } from 'antd'
import { setEnv, env } from 'utils'
import { useForceUpdate } from 'hooks'

export function ENV() {
  // const { env, setEnv } = useFetch()
  const isProd = process.env.REACT_APP_ENV === 'production'
  const forceUpdate = useForceUpdate()
  if (isProd) {
    return null
  }

  // const items: MenuProps['items'] = ['dev', 'beta', 'pre'].reduce(
  //   (map, key) => {
  //     for (let i = 0; i <= 5; i++) {
  //       map.push({
  //         label: `${key}${i || ''}`,
  //         key: `${key}${i || ''}`,
  //       })
  //     }
  //     return map
  //   },
  //   [] as any
  // )
  const items: MenuProps['items'] = [
    { label: 'dev', key: 'dev' },
    { label: 'dev2', key: 'dev2' },
    { label: 'beta', key: 'beta' },
    { label: 'beta2', key: 'beta2' },
    // { label: 'pre', key: 'pre' },
  ]

  const onSwitchEnv = (menu: { key: string }) => {
    console.log('menu', menu)
    setEnv(menu.key)
    forceUpdate()
  }
  return (
    <Dropdown menu={{ items, onClick: onSwitchEnv }}>
      <Button>
        {env}
        <DownOutlined />
      </Button>
    </Dropdown>
  )
}
